import { render, staticRenderFns } from "./ChildrenPresence.vue?vue&type=template&id=4aaf9643&scoped=true&"
import script from "./ChildrenPresence.vue?vue&type=script&lang=js&"
export * from "./ChildrenPresence.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenPresence.vue?vue&type=style&index=0&id=4aaf9643&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf9643",
  null
  
)

export default component.exports